module.exports = __webpack_public_path__ + "images/featured-product-texture-mob.ca3787dd91.svg";